import { PaginationType } from "../../types/paginationType";
import { ArticleImageType, LearnInfoType } from "./LearnTypes";

export type McqChoiceType = {
  type: string;
  choiceText: string;
  choiceImgUrl: string;
};

export type QuestionFileType = { questionFileUrl: string };
export type TemplateResponseFileType = { questionTemplateFileUrl: string };
export type FrqSubmittedSolutionDocumentType = {
  s3Url: string;
  documentDescription: string;
};
export interface AdminMcqType {
  customId: string;
  creator: string;
  collaborators: string[];
  tags: string[];
  points: number;
  question: string;
  questionFiles?: QuestionFileType[];
  choices: McqChoiceType[];
  correctChoiceIndex?: number;
  latexQuestion: boolean;
  latexChoices: boolean;
  maxAttempts: number;
  visibility: string;
}

export interface AdminFrqType {
  customId: string;
  creator: string;
  collaborators: string[];
  tags: string[];
  question: string;
  templateResponse?: string;
  questionFiles?: QuestionFileType[];
  templateResponseFiles: TemplateResponseFileType[];
  maxAttempts: number;
  points: number;
  isPublic: boolean;
  latexQuestion: boolean;
  latexAnswers: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface AdminUsersMcqSolutions {
  _id: string;
  user: string;
  questionAttempts: number;
  isCorrect: boolean[];
  selectedChoiceIndex: number[];
  course: string;
  score: number;
  answerIsCorrect: boolean;
  question: AdminMcqType;
  createdAt: string;
  updatedAt: string;
}

export enum ReviewStatus {
  Pending = "pending",
  Approved = "accepted",
  Rejected = "rejected",
}

export interface AdminUsersFrqSolutions {
  _id: string;
  user: string;
  question: AdminFrqType;
  course: string;
  questionAttempts: number;
  solutions: string;
  reviewer: string;
  reviewerRemarks: string;
  reviewDate: string;
  reviewStatus: ReviewStatus;
  score: number;
  submittedDocuments: FrqSubmittedSolutionDocumentType[];
  createdAt: string;
  updatedAt: string;
}

export type AdminCourseCollaboratorType = {
  _id: string;
  email: string;
  firstName: string;
  lastName: string;
  learn: string[];
  personalInformation: { profilePhoto: string };
};

export type AdminCourseUserType = {
  _id: string;
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  userName: string;
  profilePhoto: string;
  lastActivity: string;
  role: string;
  progress: string;
  isCertificateSent: boolean;
  course: string;
  createdAt: string;
  updatedAt: string;
  usersFrqSolutions?: {
    solutions?: AdminUsersFrqSolutions[];
    pagination?: PaginationType;
  };
  usersMcqSolutions?: {
    solutions?: AdminUsersMcqSolutions[];
    pagination?: PaginationType;
  };
};

export type AdminCourseUserListType = {
  courseUsers: Array<AdminCourseUserType>;
  pagination: PaginationType;
  timeStamp: number;
};

// referenced from mongo schema in backend
export type AdminArticleType = {
  courseName: string;
  courseDescription: string;
  totalStudents: string | number;
  content: LearnInfoType[];
  courseId: string;
  courseAuthorUserName: string;
  _id?: string;
  customId?: string;
  collaborators?: AdminCourseCollaboratorType[];
  visibility?: string;
  isPublished?: boolean;
  repoUrl?: string;
  editLock?: boolean;
  classesRunning?: any;
  gitRepoURL?: string;
  isLocked?: any;
  courseProgressPoints?: number;
  user?: string;
  email?: string;
  userList?: AdminCourseUserListType;
  createdAt?: string;
  orgData?: any;
  overallCourseProgress?: number;
  orgRef?: string;
  // blogs specific fields
  tags?: string[];
  datePublished?: string;
  imageLink?: ArticleImageType;
  likes?: number;
  dislikes?: number;
  views?: number;
  // Todo: below fields can be populated from the api, and get users email, and profile photo,
  // to show the first 5 persons in a MUI Grouped avatar component
  viewedBy?: string[];
  likedBy?: string[];
  dislikedBy?: string[];
  bookmarkedBy?: string[];
};

export enum AdminGraderType {
  gradingCourse = "gradingCourse",
  gradingUsersList = "gradingUsersList",
  gradingFrq = "gradingFrq",
  gradingMcq = "gradingMcq",
  gradingUser = "gradingUser",
}

export enum CourseUsersType {
  "Student" = "Student",
  "Teaching Assistant" = "Teaching Assistant",
  "Instructor" = "Instructor",
  "Owner" = "Owner",
  "Collaborator" = "Collaborator",
}

export type AddUserToCoursePayloadType = {
  courseId: string;
  newUserEmail: string;
  userRole: CourseUsersType;
};

export type RemoveUserFromCoursePayloadType = {
  courseId: string;
  removingUserId: string;
};

export enum ApiResponseType {
  "success" = "success",
  "failure" = "failure",
  "pending" = "pending",
  "loading" = "loading",
}
export type AddMultipleUserListItemType = {
  id:string;
  email: string;
  role: CourseUsersType;
  status: ApiResponseType;
  errorMessage?: string;
};

export type AddMultipleUsersToCoursePayloadType = {
  usersList: Array<AddMultipleUserListItemType>;
  courseId: string;
  callBackFunctionAfterSuccess: () => void;
};
